module.exports = "/img/16.a79baf.webp";